// ==========================
// HEADER FIJO AL HACER SCROLL
// ==========================
document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('header.header');

  if (!header) return;

  header.style.position = 'fixed';
  header.style.top = '100px';
  header.style.left = '0';
  header.style.right = '0';
  header.style.zIndex = '1000';
  header.style.transition = 'top 0.3s ease';

  window.addEventListener('scroll', function() {
    if (window.scrollY > 0) {
      header.style.top = '39px';
    } else {
      header.style.top = '100px';
    }
  });
});

// ==========================
// MODAL DE OPCIONES
// ==========================
document.addEventListener('DOMContentLoaded', function() {
  const openBtn = document.getElementById('open-options-modal');
  const modal = document.getElementById('options-modal');
  const closeBtn = modal?.querySelector('.close-options-modal');

  if (openBtn && modal && closeBtn) {
    openBtn.addEventListener('click', () => {
      modal.style.display = 'block';
    });
    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
    });
    window.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.style.display = 'none';
      }
    });
  }
});

// ==========================
// CAMBIO DE FUENTE LABELS
// ==========================
const changeLabelFontSize = () => {
  const labels = document.querySelectorAll(".spb-productdescfont");

  if (labels.length > 0) {
    labels.forEach(label => {
      label.style.setProperty("font-size", "20px", "important");
    });
    clearInterval(waitForLabels);
  }
};

const waitForLabels = setInterval(changeLabelFontSize, 300);

// ==========================
// CARRUSEL MÓVIL (≤1024px) CENTRADO REAL
// ==========================
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth > 1024) return; // SOLO MÓVIL / TABLET

  const slider = document.querySelector(".carousel-3d__slider");
  const slides = document.querySelectorAll(".carousel-3d__slide");
  const total = slides.length;
  let current = 0;

  // 🚫 DETENER CUALQUIER AUTOPLAY EXISTENTE
  for (let i = 1; i < 99999; i++) {
    clearInterval(i);
    clearTimeout(i);
  }

  // Si el carrusel usa requestAnimationFrame, lo detenemos
  if (window.cancelAnimationFrame) {
    for (let i = 1; i < 99999; i++) {
      cancelAnimationFrame(i);
    }
  }

  function updateClasses() {
    slides.forEach((slide, index) => {
      slide.className = "carousel-3d__slide"; // limpiar todas las clases
      slide.style.transition = "transform 0.3s, opacity 0.3s";
      slide.style.opacity = "0.5";
      slide.style.transform = "scale(0.9)";
    });

    const leftIndex = (current - 1 + total) % total;
    const rightIndex = (current + 1) % total;

    slides[current].classList.add("active");
    slides[current].style.opacity = "1";
    slides[current].style.transform = "scale(1)";

    slides[leftIndex].classList.add("left1");
    slides[leftIndex].style.opacity = "0.5";
    slides[leftIndex].style.transform = "scale(0.9)";

    slides[rightIndex].classList.add("right1");
    slides[rightIndex].style.opacity = "0.5";
    slides[rightIndex].style.transform = "scale(0.9)";

    // CENTRAR EL SLIDE ACTIVO
    const sliderWidth = slider.offsetWidth;
    const slideWidth = slides[current].offsetWidth;
    const offset = slides[current].offsetLeft + slideWidth / 2 - sliderWidth / 2;
    slider.style.transform = `translateX(${-offset}px)`;
  }

  const btnRight = document.querySelector(".carousel-arrow.right");
  const btnLeft = document.querySelector(".carousel-arrow.left");

  if (btnRight) {
    btnRight.addEventListener("click", () => {
      current = (current + 1) % total;
      updateClasses();
    });
  }
  if (btnLeft) {
    btnLeft.addEventListener("click", () => {
      current = (current - 1 + total) % total;
      updateClasses();
    });
  }

  // Inicializar
  updateClasses();

  // Ajustar si se cambia el tamaño de pantalla
  window.addEventListener("resize", () => {
    if (window.innerWidth <= 1024) updateClasses();
  });

  // ==========================
  // BLOQUEO BRUSCO DE ARRASTRE EN MÓVIL
  // ==========================
  
});
